import PropTypes from "prop-types";

import ScrollableHandler from "./ScrollableHandler";

import "./Overlay.scss";

function Overlay({ children, ...props }) {
  return (
    <div className="trl-overlay" {...props}>
      {!!children && (
        <>
          <ScrollableHandler className="trl-overlay-scrollable-handler">
            <div
              style={{
                backgroundColor: "lightgray",
                borderRadius: 2,
                height: 4,
                margin: 4,
                width: 32,
              }}
            />
            <div className="trl-overlay-handler-zone" />
          </ScrollableHandler>
          {children}
        </>
      )}
    </div>
  );
}

Overlay.propTypes = {
  children: PropTypes.node,
};

export default Overlay;
